import React from "react";
import { Link } from "react-router-dom";

import "./styles.scss";

interface IProps {
  to: string;
}

const BackButton: React.FC<IProps> = props => {
  return (
    <Link to={props.to} className="back-button">
      <div className="back-arrow" />
      <p>На главную</p>
    </Link>
  );
};

export default BackButton;
